var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Mechanisms',{attrs:{"typeMECH":"USM","propsDateShift":_vm.dateShift,"propsShift":_vm.shift}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }